module.exports = __webpack_public_path__ + "static/media/events_10.f8ee702a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/events/JPEG/events_10.jpg
// module id = 5928
// module chunks = 0